import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { IconButton } from "@material-ui/core";

import Icon from "components/Icon";
import ClientModal from "screens/Clients/components/ClientModal";

import { saveClient } from "store/client/actions";

const EditClientButton = ({ item }) => {
  const dispatch = useDispatch();

  const initialValues = {
    name: item.name || "",
    code: item.code || "",
    status: item.status || "active",
    address: item.address || "",
    email: item.email || "",
    color: item.color || "#1976D2",
    contactPersonName: item.contactPersonName || "",
    contactPersonPhone: item.contactPersonPhone || "",
    notes: item.notes || "",
  };

  const handleClientEdit = (values) => {
    dispatch(saveClient(values, item._id));
  };

  return (
    <ClientModal
      onSubmit={handleClientEdit}
      initialValues={initialValues}
      cancelActionText={"Discard"}
      submitActionText={"Save"}
      title={`Edit client ${item.name}`}
      isEdit={true}
      OpenerComponent={(props) => (
        <IconButton {...props}>
          <Icon name={"edit"} color={"black"} />
        </IconButton>
      )}
    />
  );
};

EditClientButton.propTypes = {
  item: PropTypes.object.isRequired,
};

export default EditClientButton;

